import(/* webpackMode: "eager" */ "/home/circleci/project/src/app/error.tsx")